/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse20026
 */
export interface InlineResponse20026 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20026
     */
    nickname: string;
}

export function InlineResponse20026FromJSON(json: any): InlineResponse20026 {
    return InlineResponse20026FromJSONTyped(json, false);
}

export function InlineResponse20026FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20026 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nickname': json['nickname'],
    };
}

export function InlineResponse20026ToJSON(value?: InlineResponse20026 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nickname': value.nickname,
    };
}


